import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"statue-of-jesus"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14 18H15L16 22H8L9 18H10H14Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14 7H21V8L14 11V7ZM14 7H10M14 7V15M10 11L3 8V7H10M10 11V7M10 11L10 18M10 11L14 15M14 18H15L16 22H8L9 18H10M14 18H10M14 18V15M11 2H13V4H11V2Z","strokeWidth":"props.strokeWidth"}}]}]};

const StatueOfJesus = Vue.extend<IconProps>({
  name: 'StatueOfJesusIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'statue-of-jesus',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default StatueOfJesus;
